/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Activity_Bud_PickingInputs */

const vi_care_log_activity_bud_picking = /** @type {(inputs: Care_Log_Activity_Bud_PickingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhặt nụ`)
};

/**

* @param {Care_Log_Activity_Bud_PickingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_activity_bud_picking = /** @type {((inputs?: Care_Log_Activity_Bud_PickingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Activity_Bud_PickingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_activity_bud_picking(inputs)
});